import { array } from 'fp-ts';
import { PortfolioVoucherOverview, VoucherCode } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    IconName,
    Table,
    ActionToolbarButton,
    ActionToolbar,
    TableHeader,
    TableProvider,
    useFullRowSelection,
    useTableState,
} from '@optimus-web/core';
import { DeleteVoucherCodesWrapper } from '../../../sections/components/vouchers/voucherCodes/DeleteVoucherCodesWrapper';
import { useColumns } from './tableMapping';

interface Props {
    voucher: PortfolioVoucherOverview | undefined;
}

export const VoucherCodesTable = ({ voucher }: Props) => {
    const [tableState, setTableState] = useTableState<VoucherCode>();
    const voucherCodes = voucher?.voucherCodes || [];

    const { selectedRowsData, selectedRowsIds, hasRowsSelected, rowSelection, setRowSelection, resetRowSelection } =
        useFullRowSelection(voucherCodes);

    const columns = useColumns({ onDeleteSuccess: resetRowSelection });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
            <TableHeader
                title={<LocalizedText textKey={TextKey.VoucherCodesTableHeader} />}
                subTitle={voucherCodes.length || '0'}
            />

            <ActionToolbar
                disabled={!hasRowsSelected}
                leftSide={
                    array.isNonEmpty(selectedRowsIds) && (
                        <LocalizedText
                            textKey={TextKey.SelectedItems}
                            substitutes={{ count: selectedRowsIds.length }}
                        />
                    )
                }
                rightSide={
                    <DeleteVoucherCodesWrapper
                        voucherCodes={selectedRowsData}
                        onSuccess={resetRowSelection}
                        renderButtonComponent={(onClick) => (
                            <ActionToolbarButton
                                disabled={array.isEmpty(selectedRowsData)}
                                icon={IconName.Delete}
                                onClick={onClick}
                            >
                                <LocalizedText textKey={TextKey.Delete} />
                            </ActionToolbarButton>
                        )}
                    />
                }
            />
            <Table
                data={voucherCodes}
                amountOfRows={voucherCodes.length}
                rowSelection={{ rowSelection, onRowSelectionChange: setRowSelection }}
                uniqueRowId="id"
                fixedFirstColumn
            />
        </TableProvider>
    );
};
